<script context="module">
  import NewsletterCard from "./NewsletterCard.svelte";
</script>

<script>
  export let newsletters;
  export let hideOverlay = false;
</script>

<div class="grid grid-cols-1 gap-3 mr-0 overflow-clip md:grid-cols-2 md:-mr-1 lg:grid-cols-3">
  <slot />
  {#each newsletters as newsletter, i (newsletter.id)}
    <NewsletterCard bind:newsletter {hideOverlay} />
  {/each}
</div>
